import React, { Component } from "react";
import ReactDOM1 from "react-dom";

import "./App.scss";
//import{Route, Switch, withRouter, HashRouter as Router } from "react-router-dom";
//import{Route, Switch, withRouter, BrowserRouter as Router } from "react-router-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Home from "./home/Home";
import About from "./about/About";
// import SecondExample from './home/SecondExample';
import Header from "./components/Header";
import Sign from "./login/Sign";
import Training from "./training/Training";
import TrainingSchedule from "./training/TrainingSchedule";
import PastTraining from "./training/PastTraining";
import PastTrainingSchedule from "./training/PastTrainingSchedule";
import Article from "./glimpses/Article";
import DiscussionBoard from "./discussion/DiscussionBoard";
import Category_tag_filter from "./discussion/Category_tag_filter";
import ReadThread from "./discussion/ReadThread";
import CreateThread from "./discussion/CreateThread";
import ArticleSingle from "./glimpses/ArticleSingle";
import News from "./govt-circular-gr/GovtCircular";
import NewsSingle from "./govt-circular-gr/NewsSingle";
// import Blog from "./blog/Blog";
import BlogInner from "./blog/BlogInner";
import Faq from "./faq/Faq";
import Contact from "./contact/Contact-us";
import Sample from "./discussion/Sample";
import { isLogin } from "./utils";
//import NetworkDetector from './utils/NetworkDetector';

import TermsCondition from "./terms-condition/TermsCondition";
import Webinar from "./webinar/Webinar";
import Upcoming_webinar from "./webinar/Upcoming_webinar";
import Past_webinar from "./webinar/Past_webinar";
import VideoGlimses from "./glimpses/VideoGlimses";
import PastWebinarSchedule from "./webinar/Past-Webinar-Schedule";

//import { initializeFirebase } from './push-notification';
import firebase from "./firebase";
import axios from "axios";
import { apiURL, getBuildDate } from "./utils";
import PrivacyPolicy from "./privacy-policy/Privacy-Policy";
//import ReactGA from 'react-ga';

import withClearCache from "./ClearCache";
import packageJson from "../package.json";
import PopUp from "./components/PopUp";
import ProfileUpdate from "./components/Profile/ProfileUpdate";
import ProfileInfo from "./components/Profile/ProfileInfo";
import Profile from "./components/Profile/Profile";
import BookMark from "./components/BookMark";
import ClearCache from "react-clear-cache";
import AcademicEssays from "./components/Article/AcademicEssays";
import SuccessStories from "./components/Article/SuccessStories";
import Interviews from "./components/Article/Interviews";
import BookRecommendations from "./components/Article/BookRecommendations";
import SelfDevelopment from "./components/Article/SelfDevelopment";
import TrForTeacher from "./components/TR-For-Teacher/TrForTeacher";
import SingleArticle from "./components/Article/SingleArticle";
import Blog from "./components/Article/Blog";
import SingleBlog from "./components/Article/SingleBlog";
import ArticleNews from "./components/Article/ArticleNews";
import MHBoard from "./govt-circular-gr/MHBoard";
import CBSEBoard from "./govt-circular-gr/CentralBoard";
import CentralBoard from "./govt-circular-gr/CentralBoard";
import Achievements from "./components/Achievements/Achievements";
import PwaNavMenu from "./components/PwaNavMenu";
import { PWAContext } from "./utils/PwaAppContext.jsx";
import { PwaNavigation } from "./components/PwaNavigation/PwaNavigation.jsx";
import { AuthRoute, PrivateRoute , PublicRoute} from "./AuthRoutes.js";
import Promotion from "./components/Promotion/Promotion.jsx";

const ClearCacheComponent = withClearCache(MainApp);

function MainApp(props) {
  return (
    <div className="App">
      <p>Build date: {getBuildDate(packageJson.buildDate)}</p>
    </div>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      navBarHeight: 0,
      screenWidth: 0,
    };
  }

  calculateNavBarHeight = () => {
    const screenHeight = window.screen.height;
    const viewportHeight = window.innerHeight;
    const navHeight = screenHeight - viewportHeight;
    const screenInnerWidth = window.screen.width;
    this.setState({ navBarHeight: navHeight, screenWidth: screenInnerWidth });
    console.log(this.state);
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const openPopupParam = searchParams.get("openpopup");
    if (openPopupParam === "true") {
      this.setState({ showPopup: true });
    }
    this.calculateNavBarHeight();
    window.addEventListener('resize', this.calculateNavBarHeight);

    document.querySelectorAll("a[target=_blank]").forEach((link) => {
      if (!link.hasAttribute("rel")) {
        link.setAttribute("rel", "noopener noreferrer");
      }

      // if (isPWA) {
      //   link.addEventListener("click", (event) => {
      //     event.preventDefault(); 
      //     window.open(link.href, "_system");
      //   });
      // }
    });

    // const isPWAOpenLink =
    //   window.matchMedia("(display-mode: standalone)").matches ||
    //   window.navigator.standalone;

    // const urlParams = new URLSearchParams(window.location.search);
    // const isSharedLink = urlParams.has("source");

    // if (!isPWAOpenLink && isSharedLink) {
    //   // If PWA is NOT installed, redirect to browser
    //   window.location.href = "https://navdisha.navneet.com/";
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateNavBarHeight);
  }

  handleClosePopup = () => {
    this.setState({ showPopup: false });
    // window.location.replace("https://www.navdisha.co.in/");
  };


  render() {
    return (
      <PWAContext.Consumer>
        {({ isPWA }) => (
          <React.Fragment>
            <PopUp
              open={this.state.showPopup}
              handleClose={this.handleClosePopup}
            />
            <Router basename="/">
              <div style={{ overflowX: isPWA ? "hidden" : "", overflow: "scroll" }}>
                {isPWA && <PwaNavMenu />}
                <Switch>
                  <PublicRoute path="/about-us" component={About} />
                  <Route path="/header" component={Header} />
                  <AuthRoute path="/sign" component={Sign} />
                  <PrivateRoute
                    path="/training/:trainingId/:trainingTitle"
                    component={Training}
                  />
                  <PublicRoute path="/overview" component={TrainingSchedule} />
                  <PublicRoute path="/past-trainings" component={PastTraining} />
                  <PrivateRoute
                    path="/past-training-schedule/:trainingId/:trainingTitle"
                    component={PastTrainingSchedule}
                  />
                  <PublicRoute path="/articles" component={Article} />
                  <PrivateRoute
                    path="/article/:articleId/:articleTitle"
                    component={SingleArticle}
                  />
                  <PublicRoute path="/discussion-board" component={DiscussionBoard} />
                  <PrivateRoute
                    path="/discussion-board/:objectId"
                    component={Category_tag_filter}
                  />
                  <PublicRoute path="/maharashtra-state-board" component={MHBoard} />
                  <PublicRoute path="/central-board" component={CentralBoard} />
                  <PrivateRoute path="/news/:newsId/:newsTitle" component={NewsSingle} />
                  <PublicRoute path="/blogs" component={Blog} />
                  <PrivateRoute path="/blog/:blogId/:blogTitle" component={SingleBlog} />
                  <PublicRoute path="/faq" component={Faq} />
                  <PublicRoute path="/contact-us" component={Contact} />
                  <PublicRoute path="/academic-essays" component={AcademicEssays} />
                  <PublicRoute path="/success-stories" component={SuccessStories} />
                  <PublicRoute path="/interviews" component={Interviews} />
                  <PublicRoute path="/news" component={ArticleNews} />
                  <PublicRoute
                    path="/book-recommendations"
                    component={BookRecommendations}
                  />
                  <PublicRoute path="/self-development" component={SelfDevelopment} />

                  <PrivateRoute
                    path="/thread-answer/:threadId/:threadTitle"
                    component={ReadThread}
                  />
                  <PrivateRoute path="/sample/:threadId/:threadTitle" component={Sample} />
                  <PublicRoute path="/create-new-thread" component={CreateThread} />
                  <PublicRoute path="/terms-and-conditions" component={TermsCondition} />
                  <PublicRoute path="/privacy-policy" component={PrivacyPolicy} />
                  <PrivateRoute
                    path="/webinar/:webinarId/:webinarTitle"
                    component={Webinar}
                  />
                  <PublicRoute path="/upcoming-webinars" component={Upcoming_webinar} />
                  <PublicRoute path="/past-webinars" component={Past_webinar} />
                  <PrivateRoute
                    path="/past-webinar-schedule/:webinarId/:webinarTitle"
                    component={PastWebinarSchedule}
                  />
                  <Route path="/update-profile" component={ProfileUpdate} />
                  <Route path="/profile-info" component={Profile} />
                  <PublicRoute path="/tr-for-teacher" component={Promotion} />
                  <PrivateRoute path="/bookmark" component={BookMark} />
                  <Route path="/achievements" component={Achievements} />
                  <PrivateRoute path="/video" component={VideoGlimses} />
                  <PublicRoute path="/pwa-navigation" component={PwaNavigation} />
                  <PublicRoute path="/" component={Home} />
                  <Redirect from="*" to="/" />
                </Switch>
              </div>
            </Router>
          </React.Fragment>
        )}
      </PWAContext.Consumer>
    );
  }
}
export default App;